import { SET_CONFIG_DATA, ConfigurationStateInterface, ConfigActionTypes } from './configuration.types';
export function setConfigData(data: ConfigurationStateInterface): ConfigActionTypes {
  return {
    type: SET_CONFIG_DATA,
    payload: data
  };
}
